/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetDiscoveryProfileByClaimIdQueryVariables = Types.Exact<{
  claimId: Types.Scalars["Int"];
}>;

export type GetDiscoveryProfileByClaimIdQuery = {
  profiles: Array<{
    fields: Array<
      Pick<Types.FieldWithAnswer, "slug" | "field_type" | "updated_at"> & {
        answer?: Types.Maybe<Pick<Types.FieldAnswer, "value" | "updated_at">>;
      }
    >;
  }>;
};

export const GetDiscoveryProfileByClaimIdDocument = gql`
  query GetDiscoveryProfileByClaimId($claimId: Int!) {
    profiles: claims(
      take: 1
      where: {
        id: { equals: $claimId }
        pipeline: { is: { type: { equals: "discovery-profiles" } } }
      }
    ) {
      fields {
        slug
        field_type
        updated_at
        answer {
          value
          updated_at
        }
      }
    }
  }
`;

/**
 * __useGetDiscoveryProfileByClaimIdQuery__
 *
 * To run a query within a React component, call `useGetDiscoveryProfileByClaimIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscoveryProfileByClaimIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscoveryProfileByClaimIdQuery({
 *   variables: {
 *      claimId: // value for 'claimId'
 *   },
 * });
 */
export function useGetDiscoveryProfileByClaimIdQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetDiscoveryProfileByClaimIdQuery,
    GetDiscoveryProfileByClaimIdQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetDiscoveryProfileByClaimIdQuery,
    GetDiscoveryProfileByClaimIdQueryVariables
  >(GetDiscoveryProfileByClaimIdDocument, baseOptions);
}
export function useGetDiscoveryProfileByClaimIdLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetDiscoveryProfileByClaimIdQuery,
    GetDiscoveryProfileByClaimIdQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetDiscoveryProfileByClaimIdQuery,
    GetDiscoveryProfileByClaimIdQueryVariables
  >(GetDiscoveryProfileByClaimIdDocument, baseOptions);
}
export type GetDiscoveryProfileByClaimIdQueryHookResult = ReturnType<
  typeof useGetDiscoveryProfileByClaimIdQuery
>;
export type GetDiscoveryProfileByClaimIdLazyQueryHookResult = ReturnType<
  typeof useGetDiscoveryProfileByClaimIdLazyQuery
>;
export type GetDiscoveryProfileByClaimIdQueryResult =
  ApolloReactCommon.QueryResult<
    GetDiscoveryProfileByClaimIdQuery,
    GetDiscoveryProfileByClaimIdQueryVariables
  >;
